import React from "react"
import { yupResolver } from "@hookform/resolvers/yup"
import { useMutation } from "@tanstack/react-query"
import { userChangePassword } from "api/authApi"
import LoadingButton from "components/Common/LoadingButton"
import InputRHF from "components/RHF/InputRHF"
import { change_password_schema } from "helpers/validationSchema"
import { t } from "i18next"
import { useForm } from "react-hook-form"
import { toast } from "react-toastify"
import { Card, CardBody, CardTitle } from "reactstrap"

function SecurityProfilePage() {
  const { handleSubmit, control } = useForm({
    defaultValues: {
      new_password1: "",
      new_password2: "",
    },
    resolver: yupResolver(change_password_schema),
  })

  const { mutate, isPending } = useMutation({
    mutationFn: userChangePassword,
    onSuccess: () => {
      toast.success("success")
    },
    onError: error => toast.error(error),
  })

  return (
    <Card>
      <CardBody>
        <CardTitle className="mb-3">
          {t("update your account password")}
        </CardTitle>
        <form onSubmit={handleSubmit(mutate)} id="form_id">
          <InputRHF
            name="new_password1"
            label={t("new password")}
            placeholder={t("enter new password")}
            control={control}
          />
          <InputRHF
            name="new_password2"
            label={t("confirm password")}
            placeholder={t("enter confirm password")}
            control={control}
          />
        </form>
        <LoadingButton type="submit" isLoading={isPending} form="form_id">
          {t("change password")}
        </LoadingButton>
      </CardBody>
    </Card>
  )
}

export default SecurityProfilePage
